import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderServerlessFunctionOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderServerlessFunctionOpen",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.37 9.71h-7.84c-.22 0-.42-.14-.49-.35l-1.13-3.39a3.63 3.63 0 0 0-3.44-2.48h-3.23c-1.54 0-2.92.97-3.43 2.42l-1.5 4.54c-.13.37-.19.75-.19 1.14v1.22h17.59c.44 0 .84.28.98.7l.48 1.43 1.26 3.79 1.41 4.1c.04.1.06.21.06.32.01.57-.44 1.05-1.02 1.06h-.18a1.06 1.06 0 0 1-.81-.72l-.83-2.51-2.04-6.11h-7.08v-.16c0-.82-.65-1.66-2.11-1.66-1.14.08-2.2.58-2.98 1.42-.13.13-.25.26-.37.4H3.6c-.86-.02-1.58.66-1.6 1.52 0 .19.02.37.08.55l2.78 8.39c-.35.37-.56.85-.59 1.36-.03.43.13.85.43 1.16.41.42.98.66 1.57.65.82-.05 1.6-.38 2.22-.93l.22-.19h17.66c2 0 3.63-1.62 3.63-3.63V13.31c-.01-2-1.63-3.61-3.63-3.61Zm-13.38 5.92c-.4-.47-.76-.73-1.01-.73s-.58.16-1 2.85h1.52l-.31.62c-.23 0-1.06.08-1.31.08-.21 1.29-.38 2.45-.75 4.31-.19 1.58-1 3.02-2.27 3.99-.43.41-.98.67-1.57.73-.54 0-1.01-.34-.98-.7.05-.36.24-.7.53-.93.11-.09.19-.09.27 0 .34.3.76.5 1.2.58.59 0 .67-.93 1.06-3.26.32-1.93.54-3.19.78-4.73H8l-.06-.15.44-.56h.93c.16-.96.62-1.85 1.31-2.54.59-.64 1.39-1.04 2.26-1.12.77 0 1.1.3 1.1.64-.08.37-.28.7-.58.93-.17.08-.26.11-.39-.03Zm6.78 8.43h-3.31v-.44c.56-.09.56-.23.31-.63l-.66-1.1c-.25.35-.53.76-.71 1.08s-.2.56.4.65v.44h-2.51v-.44a2.05 2.05 0 0 0 1.43-.82c.31-.38.68-.87 1.07-1.43l-1.17-1.85c-.4-.62-.53-.77-1.24-.86v-.44h3.18v.44c-.44.09-.53.21-.34.52l.63 1c.28-.38.53-.77.68-1s.1-.44-.43-.52v-.44h2.42v.44c-.58-.01-1.12.28-1.43.77-.19.24-.5.62-.93 1.23l1.24 1.97c.25.55.76.92 1.36.99v.44Z"
    })
  }));
};